export default "__VITE_ASSET__DoABpKOK__"